import product1 from "./assets/1.png";
import product2 from "./assets/2.png";
import product3 from "./assets/3.png";
import product4 from "./assets/4.png";
import product5 from "./assets/5.png";
import product6 from "./assets/6.webp";
import product7 from "./assets/7.webp";
import product8 from "./assets/8.webp";
import product9 from "./assets/9.jpg";
import product10 from "./assets/10.webp"
import product11 from "./assets/11.webp"
import product12 from "./assets/12.webp"

export const PRODUCTS = [
  {
    id: 1,
    productName: "Iphone",
    price: 70000,
    productImage: product1,
    category: "Electronics", // Add the "category" field with the category value
  },
  {
    id: 2,
    productName: "Macbook Pro 2023 (M1)",
    price: 99999,
    productImage: product2,
    category: "Electronics", // Add the "category" field with the category value
  },
  {
    id: 3,
    productName: "Canon M50 Camera",
    price: 58999,
    productImage: product3,
    category: "Electronics", // Add the "category" field with the category value
  },
  {
    id: 4,
    productName: "WLS Van Gogh Denim Jacket",
    price: 3000,
    productImage: product4,
    category: "Clothing", // Add the "category" field with the category value
  },
  {
    id: 5,
    productName: "LED LIGHT STRIPS",
    price: 999,
    productImage: product5,
    category: "Home", // Add the "category" field with the category value
  },
  {
    id: 6,
    productName: "SPECTRUM LS TEE",
    price: 2000,
    productImage: product6,
    category: "Clothing", // Add the "category" field with the category value
  },
  {
    id: 7,
    productName: "AUTO SERVICE SHIRT BY GOLF WANG",
    price: 2999,
    productImage: product7,
    category: "Clothing", // Add the "category" field with the category value
  },
  {
    id: 8,
    productName: "DON'T TRIP UNSTRUCTURED HAT",
    price: 699,
    productImage: product8,
    category: "Accessories", // Add the "category" field with the category value
  },
  {
    id: 9,
    productName: "LEATHER BELT",
    price: 999,
    productImage: product9,
    category: "Accessories", // Add the "category" field with the category value
  },
  {
    id: 10,
    productName: "STEELBIRD GRAPHICS HELMET",
    price: 2300,
    productImage: product10,
    category: "Accessories", // Add the "category" field with the category value
  },
  {
    id: 11,
    productName: "CRAFTTER WALL LAMP",
    price: 700,
    productImage: product11,
    category: "Home", // Add the "category" field with the category value
  },
  {
    id: 12,
    productName: "HANDPAINTED STAND SHOWPIECE",
    price: 599,
    productImage: product12,
    category: "Home", // Add the "category" field with the category value
  },
];